module.exports = __webpack_public_path__ + "static/img/apple-store-badge-es-MX.bbd6b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple-store-badge-es-MX.png
// module id = n/Cj
// module chunks = 1